import React, { FunctionComponent, useEffect } from 'react';
import './AboutCountry.scss';
import { HELP_ROUTE } from '../../utils/consts';
import { ReactComponent as BackIcon } from '../../assets/icons/back.svg';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { HelpStore } from '../../store/Help';
import { buildDownloadFile, findTranslationsSelector } from '../../utils/functions';
import { useUpdateEffect } from 'react-use';
import { LocaleAttachmentsBodyType, UnionLocations } from '../../types';
import { Layout, notification, NotificationType, SegmentedButton } from '@iba-team/portal-react-components/dist';

interface AboutCountryI {
    country: Exclude<UnionLocations, 'Czech Republic'>,
    setCurrentLang:(value: string) => void,
    currentLang: string,
}

export const AboutCountry: FunctionComponent<AboutCountryI> = observer((props) => {
  const { country, setCurrentLang, currentLang } = props;
  const navigate = useNavigate();
  const {fetchAvailableAttachments,availableAttachments, downloadFile } = HelpStore;

  useEffect (() => {
    fetchAvailableAttachments(country);
  }, [country, currentLang]);

  const getTranslationSelector = findTranslationsSelector(currentLang);
  const renderDescription = () => {
    const key: keyof typeof getTranslationSelector.descriptionList = `description_${country}`;
    return getTranslationSelector.descriptionList[key];
  };
  const download = (span: HTMLSpanElement) => {
    availableAttachments?.localeTemplates.EN.forEach(i => {
      if(i.attachmentType === 'LINK') {
        span.setAttribute('href', i.ref);
      }
      else {
        span.addEventListener('click', () => downloadFile(i.ref).then((response) => {
          return response.blob();
        }).then((blob) => buildDownloadFile(blob, i.name)).catch(async e => notification.open(
          {
            title: 'Error',
            type: NotificationType.ERROR,
            description: JSON.parse(await e.text()).templateFile
          })));
      }
    });
  };

  const createAttachmentString = (span: HTMLSpanElement) => {
    availableAttachments?.localeTemplates[currentLang.toUpperCase() as unknown as keyof LocaleAttachmentsBodyType].forEach(i => {
      if(i.attachmentType === 'LINK') {
        span.innerHTML = i.ref;
      }
      else {
        span.innerHTML = i.name;
      }
    });
  };

  const getAttachmentNode = document.getElementById(`attachment_${country.toLowerCase()}_${currentLang}`);

  useUpdateEffect(()=>{
    if(getAttachmentNode){
      createAttachmentString(getAttachmentNode);
      download(getAttachmentNode);
    }
  });

  return (
    <Layout header={{layoutName: <div style={{display: 'flex', alignItems: 'center'}}>
      <BackIcon className='about-back__icon' onClick={() => navigate(HELP_ROUTE)} />
      <h2>
        { country }
      </h2>
    </div>,
    right: <SegmentedButton theme={{variant: 'neutral', color: 'grey'}} activeItem={currentLang} setActiveItem={e => setCurrentLang(e)} actionList={[{value: 'en',  text: 'en'}, {value: 'ru',  text: 'ru'}]}/>
    }} className='about'>
      <div className='about-descr'>{ renderDescription() }</div>
    </Layout>
  );
});
